import { render, staticRenderFns } from "./NewsForOrg.vue?vue&type=template&id=46fbbef6&scoped=true&"
import script from "./NewsForOrg.vue?vue&type=script&lang=js&"
export * from "./NewsForOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fbbef6",
  null
  
)

export default component.exports